const DEV_URL = 'https://itnonstop-dev.dataart.com/umbraco/graphql/';

const CAPTCHA_KEY = '6LcK3M8aAAAAADAbnmJVJkdtBw4D-G4W6lCbbzWq';

const ROUTER_TYPES = {
	faq: '/faq/',
	about: '/about-the-conference/',
	policy: '/about-the-conference/privacy-policy',
	codeOfConduct: '/about-the-conference/code-of-conduct',
	speakerContract: '/become-a-speaker/speakers-contract',
	becomePartner: '/become-a-partner',
	registerForEvent: '/register-to-the-conference',
	becomeSpeaker: '/become-a-speaker',
	reportAnAccident: '/report-an-accident',
	speakers: '/speakers',
};

const DICTIONARIES = {
	partnersButton: '[Buttons] - Become a Partner',
	speakersButton: '[Buttons] - Become a Speaker',
	allPartnersButton: '[Buttons] - See All Partners',
	allSpeakersButton: '[Buttons] - See All Speakers',
	donateButton: '[Buttons] - Donate',
	registerButton: '[Buttons] - Register Now',
	aboutDataArtTitle: '[Titles] - About DataArt Section Title',
	brandsTitle: '[Titles] - Brands Section Title',
	partnersTitle: '[Titles] - Partners Section Title',
	speakersTitle: '[Titles] - Speaker Section Title',
	footerContactsTitle: '[Footer] - Contacts Title',
	footerLinksTitle: '[Footer] - Links Title',
	footerTextUnderLogo: '[Footer] - Text under Logo',
	copyrightFirst: '[Footer] - Copyright Text Part 1',
	copyrightSecond: '[Footer] - Copyright Text Part 2',
	promoText: '[Promo card] - Text',
	promoTitle: '[Promo card] - Title',
	legalNotice: '[About] - Under Brands Text',
};

const FORMS_ENDPOINTS = {
	partnerForm: '/umbraco/api/form/partner',
	registerForm: '/umbraco/api/form/subscribe',
	speakerForm: '/umbraco/api/form/speaker',
	reportAccidentForm: '/umbraco/api/form/reportAccident',
};

const VALIDATION_PATTERNS = {
	email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	url: /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-\.@:%_\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/g,
	name: /^[a-zа-я ,.'-]+$/i,
	company: /^[A-Za-z0-9\-_()@#&*!<>/|\sА-Яа-яЁё][A-Za-z0-9\s\-_()@#&*!<>/|А-Яа-яЁё]{1,48}$/,
};

const TALK_NAMES_ARRAY = [
	'talkName',
	'talkFormat',
	'talkLanguage',
	'talkTrack',
	'talkAudienceLevel',
	'talkKeyPoints',
	'talkDescription',
	'talkCoSpeaker',
	'talkName2',
	'talkFormat2',
	'talkLanguage2',
	'talkTrack2',
	'talkAudienceLevel2',
	'talkKeyPoints2',
	'talkDescription2',
	'talkCoSpeaker2',
	'talkName3',
	'talkFormat3',
	'talkLanguage3',
	'talkTrack3',
	'talkAudienceLevel3',
	'talkKeyPoints3',
	'talkDescription3',
	'talkCoSpeaker3',
];

const FIRST_TALK_NAME_ONLY = [
	'talkName',
	'talkFormat',
	'talkLanguage',
	'talkTrack',
	'talkAudienceLevel',
	'talkKeyPoints',
	'talkDescription',
	'talkCoSpeaker',
];

const SECOND_TALK_NAME_ONLY = [
	'talkName2',
	'talkFormat2',
	'talkLanguage2',
	'talkTrack2',
	'talkAudienceLevel2',
	'talkKeyPoints2',
	'talkDescription2',
	'talkCoSpeaker2',
];

const THIRD_TALK_NAME_ONLY = [
	'talkName3',
	'talkFormat3',
	'talkLanguage3',
	'talkTrack3',
	'talkAudienceLevel3',
	'talkKeyPoints3',
	'talkDescription3',
	'talkCoSpeaker3',
];

export {
	DEV_URL,
	ROUTER_TYPES,
	DICTIONARIES,
	CAPTCHA_KEY,
	FORMS_ENDPOINTS,
	VALIDATION_PATTERNS,
	TALK_NAMES_ARRAY,
	FIRST_TALK_NAME_ONLY,
	SECOND_TALK_NAME_ONLY,
	THIRD_TALK_NAME_ONLY,
};
